export type ImpactLevel = "low" | "medium" | "high";
export type EffortLevel = "low" | "medium" | "high";
export type QuadrantType =
  | "quick-win"
  | "strategic"
  | "opportunistic"
  | "long-term";

export const IMPACT_LEVELS: ImpactLevel[] = ["high", "medium", "low"];
export const EFFORT_LEVELS: EffortLevel[] = ["low", "medium", "high"];

export const LEVEL_LABELS: Record<ImpactLevel | EffortLevel, string> = {
  low: "Low",
  medium: "Medium",
  high: "High",
};

export const QUADRANT_COLORS: Record<QuadrantType, string> = {
  "quick-win": "bg-emerald-500",
  strategic: "bg-amber-500",
  opportunistic: "bg-blue-500",
  "long-term": "bg-orange-500",
};

export const QUADRANT_BADGE_STYLES: Record<QuadrantType, string> = {
  "quick-win": "bg-emerald-500/20 text-emerald-600 dark:text-emerald-400",
  strategic: "bg-amber-500/20 text-amber-600 dark:text-amber-400",
  opportunistic: "bg-blue-500/20 text-blue-600 dark:text-blue-400",
  "long-term": "bg-orange-500/20 text-orange-600 dark:text-orange-400",
};

export function getQuadrant(
  impact: ImpactLevel,
  effort: EffortLevel,
): QuadrantType {
  if (impact === "high" && effort !== "high") return "quick-win";
  if (impact === "high" && effort === "high") return "strategic";
  if (impact !== "high" && effort !== "high") return "opportunistic";
  return "long-term";
}
